var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetaverse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4721 14.7712C36.9448 15.1119 39.2501 15.5382 41.3426 16.0377C41.5126 16.0783 41.6318 16.2307 41.6318 16.4054V23.3573C41.6318 23.6218 41.3677 23.8042 41.1205 23.7104C39.0581 22.9293 36.7936 22.3382 34.3692 21.9923C34.1825 21.9657 34.043 21.8069 34.043 21.6182V15.1459C34.0428 14.9169 34.2452 14.7398 34.4721 14.7712Z",
    fill: "#9BE6DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4721 14.7712C36.9448 15.1119 39.2501 15.5382 41.3426 16.0377C41.5126 16.0783 41.6318 16.2307 41.6318 16.4054V23.3573C41.6318 23.6218 41.3677 23.8042 41.1205 23.7104C39.0581 22.9293 36.7936 22.3382 34.3692 21.9923C34.1825 21.9657 34.043 21.8069 34.043 21.6182V15.1459C34.0428 14.9169 34.2452 14.7398 34.4721 14.7712Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6168 14.7712C17.144 15.1119 14.8388 15.5382 12.7463 16.0377C12.5763 16.0783 12.457 16.2307 12.457 16.4054V23.3573C12.457 23.6218 12.7212 23.8042 12.9684 23.7104C15.0308 22.9293 17.2953 22.3382 19.7197 21.9923C19.9064 21.9657 20.0459 21.8069 20.0459 21.6182V15.1459C20.046 14.9169 19.8437 14.7398 19.6168 14.7712Z",
    fill: "#9BE6DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6168 14.7712C17.144 15.1119 14.8388 15.5382 12.7463 16.0377C12.5763 16.0783 12.457 16.2307 12.457 16.4054V23.3573C12.457 23.6218 12.7212 23.8042 12.9684 23.7104C15.0308 22.9293 17.2953 22.3382 19.7197 21.9923C19.9064 21.9657 20.0459 21.8069 20.0459 21.6182V15.1459C20.046 14.9169 19.8437 14.7398 19.6168 14.7712Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7732 20.2729C35.6423 19.6336 35.1893 19.1086 34.5756 18.8863C32.8861 18.2746 29.6092 17.0843 29.4998 17.0167C29.1386 16.7942 28.9373 16.4117 28.9373 16.0142V12.2729H25.1537V16.0142C25.1537 16.4117 24.9524 16.7942 24.5912 17.0167C24.4818 17.0843 21.2051 18.2746 19.5154 18.8863C18.9018 19.1086 18.4488 19.6336 18.3178 20.2729L15.2266 35.3734L20.7648 39.6594H33.3259L38.8642 35.3734L35.7732 20.2729Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 20.3467C28.25 20.3467 28.5975 19.4932 29.5724 19.4932",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8419 20.3467C25.8419 20.3467 25.4944 19.4932 24.5195 19.4932",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1546 24.7197L19.9062 32.4216",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9375 24.7197L34.1859 32.4216",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3996 28.2177L35.7732 20.2729C35.6423 19.6336 35.1893 19.1086 34.5756 18.8863C32.8861 18.2746 29.6092 17.0843 29.4998 17.0167C29.1386 16.7942 28.9373 16.4117 28.9373 16.0142V12.2729H25.1537V16.0142C25.1537 16.4117 24.9524 16.7942 24.5912 17.0167C24.4818 17.0843 21.2051 18.2744 19.5154 18.8863C18.9018 19.1086 18.4488 19.6336 18.3178 20.2729L15.2266 35.3734L20.7648 39.6594H33.3259",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0469 34.3735V34.1235",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1381 23.5291V37.2598C53.1381 32.9098 49.8074 28.4312 44.3515 25.3926C44.2314 25.3257 44.1562 25.1997 44.1562 25.0622V17.4303C44.1562 17.1737 44.407 16.9912 44.6511 17.0705C49.929 18.7845 53.1381 21.0476 53.1381 23.5291Z",
    fill: "#9BE6DD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1381 23.5291V37.2598C53.1381 32.9098 49.8074 28.4312 44.3515 25.3926C44.2314 25.3257 44.1562 25.1997 44.1562 25.0622V17.4303C44.1562 17.1737 44.407 16.9912 44.6511 17.0705C49.929 18.7845 53.1381 21.0476 53.1381 23.5291Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4854 32.8832C33.5307 32.5675 37.2714 32.0369 40.5536 31.3349C41.0238 31.2342 41.4664 31.5935 41.4664 32.0744V47.5947C41.4664 47.9211 41.2573 48.2104 40.9476 48.3131C37.6053 49.4222 33.7701 50.2554 29.6102 50.6176C29.1688 50.656 28.7891 50.3067 28.7891 49.8637V33.6367C28.7891 33.2425 29.0923 32.9139 29.4854 32.8832Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1396 23.5293V38.2498C53.1396 40.5857 50.2969 43.524 45.5624 45.972C45.1459 46.1874 44.6484 45.8859 44.6484 45.4172V30.5338C44.6484 30.2105 44.8546 29.9225 45.1606 29.8184C50.1357 28.1265 53.1396 25.9305 53.1396 23.5293Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4854 32.8832C33.5307 32.5675 37.2714 32.0369 40.5536 31.3349C41.0238 31.2342 41.4664 31.5935 41.4664 32.0744V47.5947C41.4664 47.9211 41.2573 48.2104 40.9476 48.3131C37.6053 49.4222 33.7701 50.2554 29.6102 50.6176C29.1688 50.656 28.7891 50.3067 28.7891 49.8637V33.6367C28.7891 33.2425 29.0923 32.9139 29.4854 32.8832Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1396 23.5293V38.2498C53.1396 40.5857 50.2969 43.524 45.5624 45.972C45.1459 46.1874 44.6484 45.8859 44.6484 45.4172V30.5338C44.6484 30.2105 44.8546 29.9225 45.1606 29.8184C50.1357 28.1265 53.1396 25.9305 53.1396 23.5293Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8259 34.0146C47.6942 34.0303 47.5622 34.0454 47.4297 34.06",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8259 32.0503C47.6942 32.0659 47.5622 32.081 47.4297 32.0957",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7031 41.7597V36.7412",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0898 39.2956V30.8174",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0.949219 23.5291V37.2598C0.949219 32.9098 4.27997 28.4312 9.73584 25.3926C9.85597 25.3257 9.93109 25.1997 9.93109 25.0622V17.4303C9.93109 17.1737 9.68034 16.9912 9.43622 17.0705C4.15834 18.7845 0.949219 21.0476 0.949219 23.5291Z",
    fill: "#9BE6DD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0.949219 23.5291V37.2598C0.949219 32.9098 4.27997 28.4312 9.73584 25.3926C9.85597 25.3257 9.93109 25.1997 9.93109 25.0622V17.4303C9.93109 17.1737 9.68034 16.9912 9.43622 17.0705C4.15834 18.7845 0.949219 21.0476 0.949219 23.5291Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6021 32.8832C20.5568 32.5675 16.8161 32.0369 13.534 31.3349C13.0637 31.2342 12.6211 31.5935 12.6211 32.0744V47.5947C12.6211 47.9211 12.8302 48.2104 13.14 48.3131C16.4822 49.4222 20.3175 50.2554 24.4773 50.6176C24.9188 50.656 25.2985 50.3067 25.2985 49.8637V33.6367C25.2985 33.2425 24.9952 32.9139 24.6021 32.8832Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0.949219 23.5293V38.2498C0.949219 40.5857 3.79184 43.524 8.52634 45.972C8.94272 46.1874 9.44034 45.8859 9.44034 45.4172V30.5338C9.44034 30.2105 9.23422 29.9225 8.92822 29.8184C3.95309 28.1265 0.949219 25.9305 0.949219 23.5293Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6021 32.8837C20.5568 32.568 16.8161 32.0373 13.534 31.3353C13.0637 31.2347 12.6211 31.594 12.6211 32.0748V47.5952C12.6211 47.9216 12.8302 48.2108 13.14 48.3136C16.4822 49.4227 20.3175 50.2558 24.4773 50.6181C24.9188 50.6565 25.2985 50.3072 25.2985 49.8642V33.6372C25.2985 33.243 24.9952 32.9143 24.6021 32.8837Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75559 43.6302C5.81959 44.4357 7.08459 45.2267 8.52634 45.972C8.94284 46.1874 9.44034 45.8859 9.44034 45.4172V30.5338C9.44034 30.2105 9.23422 29.9225 8.92822 29.8184C3.95309 28.1265 0.949219 25.9304 0.949219 23.5293V38.2498C0.949219 39.1527 1.37559 40.1458 2.17009 41.1655",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26172 34.0146C6.39347 34.0303 6.52547 34.0454 6.65797 34.06",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26172 32.0503C6.39347 32.0659 6.52547 32.081 6.65797 32.0957",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38281 41.7597V36.7412",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99609 39.2956V30.8174",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5334 9.02966V4.61691L21.6634 4.60254C21.6634 4.60254 20.0985 6.14841 20.932 9.02966H24.5334Z",
    fill: "#9BE6DD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5334 9.02966V4.61691L21.6634 4.60254C21.6634 4.60254 20.0985 6.14841 20.932 9.02966H24.5334Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7945 5.45032V8.08307C22.6653 8.05195 22.5304 8.03495 22.3915 8.03495C21.4439 8.03495 20.6758 8.80307 20.6758 9.7507C20.6758 10.6983 21.4439 11.4664 22.3915 11.4664C22.5723 11.4664 22.7464 11.4383 22.91 11.3864C23.169 12.8232 23.9717 14.4674 26.3254 15.0587C29.1349 15.7644 32.0183 15.2196 32.0183 11.8171C32.0183 8.19295 32.0183 5.4502 32.0183 5.4502L22.7945 5.45032Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7945 5.45032V8.08307C22.6653 8.05195 22.5304 8.03495 22.3915 8.03495C21.4439 8.03495 20.6758 8.80307 20.6758 9.7507C20.6758 10.6983 21.4439 11.4664 22.3915 11.4664C22.5723 11.4664 22.7464 11.4383 22.91 11.3864C23.169 12.8232 23.9717 14.4674 26.3254 15.0587C29.1349 15.7644 32.0183 15.2196 32.0183 11.8171C32.0183 8.19295 32.0183 5.4502 32.0183 5.4502L22.7945 5.45032Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1346 6.35706V11.2473C31.1346 11.6528 30.8062 11.9818 30.4001 11.9818H23.3048C22.8994 11.9818 22.5703 11.6528 22.5703 11.2473V6.35706C22.5703 5.95156 22.8993 5.62256 23.3048 5.62256H30.4001C30.8063 5.62256 31.1346 5.95156 31.1346 6.35706Z",
    fill: "#9BE6DD"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0013 11.9817H25.3087C24.9031 11.9817 24.5742 11.6528 24.5742 11.2472V6.35706C24.5742 5.95143 24.9031 5.62256 25.3087 5.62256H32.0013C32.407 5.62256 32.7358 5.95143 32.7358 6.35706V11.2472C32.7358 11.6528 32.407 11.9817 32.0013 11.9817Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0002 5.62256H23.3048C22.8992 5.62256 22.5703 5.95143 22.5703 6.35706V11.2472C22.5703 11.6528 22.8992 11.9817 23.3048 11.9817H32.0002C32.4058 11.9817 32.7347 11.6528 32.7347 11.2472V6.35706C32.7347 5.95143 32.4058 5.62256 32.0002 5.62256Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6585 4.81271C21.7194 5.41133 21.9914 6.26508 23.3832 6.49121C24.7751 6.71733 25.0496 5.69883 25.0496 5.69883C25.0496 5.69883 25.7297 6.83821 27.2515 7.04546C28.7732 7.25271 29.4609 6.61896 29.1846 6.04946C29.1846 6.04946 32.1531 8.06333 33.2026 6.42308C34.0364 5.12021 32.3922 1.31021 27.4025 1.22933C23.4144 1.16496 21.4582 2.84471 21.6585 4.81271Z",
    fill: "#9BE6DD"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6585 4.81271C21.7194 5.41133 21.9914 6.26508 23.3832 6.49121C24.7751 6.71733 25.0496 5.69883 25.0496 5.69883C25.0496 5.69883 25.7297 6.83821 27.2515 7.04546C28.7732 7.25271 29.4609 6.61896 29.1846 6.04946C29.1846 6.04946 32.1531 8.06333 33.2026 6.42308C34.0364 5.12021 32.3922 1.31021 27.4025 1.22933C23.4144 1.16496 21.4582 2.84471 21.6585 4.81271Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9799 25.7817C25.9799 26.4711 25.421 27.0301 24.7315 27.0301H23.0312",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1094 25.7817C28.1094 26.4711 28.6682 27.0301 29.3577 27.0301H31.058",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2891 5.77197H43.7977",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2891 7.88623H47.2977",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2891 10H47.2977",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9688 15.3281L40.4994 12.7974H47.2994",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3055 49.2388L11.2717 54.2725H2.19922",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19922 46.897H3.70797",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19922 49.0112H7.20797",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19922 51.125H7.20797",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2471 42.6475C21.7935 42.1548 22.9861 40.7936 23.1809 39.0766C23.4452 36.7452 21.7696 34.6411 19.4384 34.3766C17.1071 34.1121 15.0029 35.7878 14.7384 38.1191C14.5795 39.5202 15.1214 40.8395 16.0851 41.7263L20.2471 42.6475Z",
    fill: "#9BE6DD"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2476 42.6475C19.6939 42.8241 19.0957 42.8889 18.4812 42.8191C17.5517 42.7137 16.7254 42.3156 16.0859 41.7266C16.6741 41.4496 17.1389 41.3466 17.4169 41.308L17.5304 40.3076L18.7791 40.4492L18.6642 41.4624C18.8866 41.5749 19.3533 41.833 19.9454 42.3875C19.9559 42.398 20.0831 42.5065 20.2476 42.6475Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4747 36.4067C17.4747 36.4067 16.1077 36.4404 16.2128 38.185C16.2974 39.5905 17.7925 39.0675 17.7925 39.0675L17.4747 36.4067Z",
    fill: "#1BCEB9"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4276 37.6945C20.4276 37.6945 20.3113 38.7193 20.1578 40.0727C20.0136 41.3441 18.9133 41.4255 17.8938 41.0422C17.0399 40.7222 16.8091 40.0735 16.7737 39.5265C16.7098 39.5388 16.6437 39.5417 16.5762 39.534C16.2224 39.4938 15.9679 39.1742 16.0081 38.8205C16.0482 38.4667 16.3678 38.2122 16.7216 38.2523C16.7668 38.2573 16.8096 38.2671 16.8526 38.2808C17.0174 38.3355 17.1511 38.4541 17.2262 38.6053C17.2521 38.6562 17.3009 38.6925 17.3576 38.699C17.4496 38.7093 17.5313 38.6443 17.5416 38.554C17.5421 38.5497 17.5426 38.5447 17.5423 38.5395L17.5773 37.3711L20.4276 37.6945Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9447 37.9988C17.2141 37.7884 16.8476 36.9416 17.2346 36.2871C17.3498 36.0922 17.5244 35.9266 17.7852 35.8312C18.3692 35.6176 19.0934 35.8116 19.6823 35.8476C20.0684 35.8712 20.3996 35.8076 20.5532 35.7707C20.6537 35.7464 20.7561 35.8127 20.7691 35.9153C20.7814 36.0126 20.7433 36.1611 20.5726 36.3828C20.5726 36.3828 20.7606 36.4042 21.1588 36.2906C21.2569 36.2626 21.3594 36.3236 21.3807 36.4233C21.4163 36.5908 21.3874 36.8642 21.0238 37.1877L21.2913 37.1594C21.3904 37.1489 21.4789 37.2223 21.4861 37.3217C21.5079 37.6264 21.4107 38.2238 20.3499 38.3472C19.6454 38.4291 18.6518 38.2024 17.9447 37.9988Z",
    fill: "#1BCEB9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M15.168 43.6123C17.423 44.2473 19.8655 44.7523 22.4517 45.0798",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M15.168 46.061C17.423 46.696 19.8655 47.201 22.4517 47.5285",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0765 51.5517H34.3633C34.0182 51.5517 33.7383 51.2718 33.7383 50.9267V46.1968C33.7383 45.8517 34.0182 45.5718 34.3633 45.5718H42.0765C42.4217 45.5718 42.7015 45.8517 42.7015 46.1968V50.9267C42.7015 51.2719 42.4218 51.5517 42.0765 51.5517Z",
    fill: "#9BE6DD"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M42.702 46.1973L38.5573 48.8465C38.352 48.9776 38.0894 48.9776 37.8842 48.8465L33.7383 46.1973C33.7383 45.851 34.0183 45.5723 34.3633 45.5723H42.077C42.422 45.5723 42.702 45.851 42.702 46.1973Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0765 51.5517H34.3633C34.0182 51.5517 33.7383 51.2718 33.7383 50.9267V46.1968C33.7383 45.8517 34.0182 45.5718 34.3633 45.5718H42.0765C42.4217 45.5718 42.7015 45.8517 42.7015 46.1968V50.9267C42.7015 51.2719 42.4218 51.5517 42.0765 51.5517Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6719 35.6366C34.2244 35.3816 36.6356 35.0391 38.8644 34.6216",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6719 38.2003C34.2244 37.9465 36.6356 37.604 38.8644 37.1865",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6719 40.7655C34.2244 40.5105 36.6356 40.1692 38.8644 39.7505",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M36.582 42.7072C37.362 42.5854 38.1233 42.4547 38.8643 42.3154",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaverse);
export default __webpack_public_path__ + "static/media/metaverse.df35687db7c150edf80e4fac13c3ea07.svg";
export { ForwardRef as ReactComponent };